import { rankings } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            热门榜单
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            大家都在看
          </h2>
          <p className="mt-2 text-sm text-foreground-600">综合热度与口碑的实力推荐</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {rankings.map((item) => (
            <div key={item.rank} className="group cursor-pointer">
              <div className="relative rounded-lg overflow-hidden bg-background-200 aspect-[3/4]">
                <img
                  src={item.image}
                  alt={`${item.title} - 新视觉影视高清推荐`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 left-2 w-7 h-7 rounded-lg bg-background-950/70 backdrop-blur-sm flex items-center justify-center">
                  <span className="text-xs font-bold text-background-50">{item.rank}</span>
                </div>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
                  <span className="text-xs text-background-50/80">{item.category}</span>
                </div>
              </div>
              <h3 className="mt-2.5 text-sm font-semibold text-foreground-950 truncate">{item.title}</h3>
              <div className="flex items-center gap-1 mt-1">
                <i className="ri-fire-line text-accent-500 text-xs"></i>
                <span className="text-xs text-foreground-600">热度 {item.heat}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="#index"
            onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-foreground-950 font-medium transition-colors cursor-pointer"
          >
            查看更多分类 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}